(function () {

	'use strict';

	/*global $:true */

	// Generic driver for the "Form" content element (CType "form") - a *sibling* of the legacy,
	// FRUEH-hardcoded cologic-contactForm.js, not a replacement for it: that file is bespoke to a
	// fixed set of field names/ids and isn't reused here. Everything here works off the data-*
	// attribute contract Form.fluid.html renders (data-topics/data-required-topics per field
	// wrapper), so it has no per-project field knowledge at all.

	let cologicFormElement = {

		initFormElement: function () {
			let that = this;

			$('.bte-form').each(function () {
				that.applyTopic(this, $('.form-topic-select', this).val());
			});

			$('.bte-form .form-topic-select').on('change', function () {
				that.applyTopic($(this).closest('.bte-form')[0], $(this).val());
			});

			$('.bte-form').on('submit', function (e) {
				e.preventDefault();
				that.handleSubmit(this);
			});

			// Immediate feedback on file selection, rather than only at submit time.
			$('.bte-form').on('change', '.form-field-wrap--file input[type="file"]', function () {
				that.validateFileField($(this).closest('.form-field-wrap'));
			});
		},

		// Shows/hides each field wrapper depending on whether the selected topic's
		// data-topics list includes it (a field with no data-topics at all - i.e. not
		// assigned to any topic yet - stays hidden, same as "not part of this form" would).
		applyTopic: function (form, topicKey) {
			let $form = $(form);

			$form.find('.form-topic-intro').hide();
			if (topicKey) {
				$form.find('.form-topic-intro[data-topic="' + topicKey + '"]').show();
			}

			$form.find('.form-field-wrap').each(function () {
				let $wrap = $(this);
				let topics = String($wrap.data('topics') || '').split(',').filter(function (value) { return value !== ''; });
				let visible = topicKey !== '' && topics.indexOf(topicKey) !== -1;
				$wrap.toggle(visible);
				if (!visible) {
					$wrap.removeClass('has-error');
				}
			});
		},

		isFieldRequiredForTopic: function ($wrap, topicKey) {
			let requiredTopics = String($wrap.data('requiredTopics') || '').split(',').filter(function (value) { return value !== ''; });
			return topicKey !== '' && requiredTopics.indexOf(topicKey) !== -1;
		},

		// Custom validation rather than native HTML "required" toggling - a checkbox GROUP
		// ("at least one of these checked") has no native HTML equivalent of "required" (native
		// required on a checkbox means THAT ONE must be checked, not "at least one in the
		// group"), so every field type is validated the same custom way here instead of mixing
		// native and custom validation.
		validateForm: function (form) {
			let that = this;
			let $form = $(form);
			let valid = true;
			let topicKey = $form.find('.form-topic-select').val() || '';

			$form.find('.form-field-wrap:visible').each(function () {
				let $wrap = $(this);
				let fieldType = $wrap.data('fieldType');
				let isRequired = that.isFieldRequiredForTopic($wrap, topicKey);

				// File fields have their own count/type/size checks (which apply whenever
				// files were actually selected, required or not) - handled separately below
				// rather than folded into the generic "is something filled in" check.
				if (fieldType === 'file') {
					if (!that.validateFileField($wrap, isRequired)) {
						valid = false;
					}
					return;
				}

				$wrap.removeClass('has-error');
				$wrap.find('.form-field-error').text('');

				if (!isRequired) {
					return;
				}

				let filled;
				if (fieldType === 'checkbox') {
					filled = $wrap.find('input[type="checkbox"]:checked').length > 0;
				} else if (fieldType === 'radio') {
					filled = $wrap.find('input[type="radio"]:checked').length > 0;
				} else {
					filled = $.trim($wrap.find('input, select, textarea').val() || '') !== '';
				}

				if (!filled) {
					valid = false;
					$wrap.addClass('has-error');
					$wrap.find('.form-field-error').text(that.getRequiredMessage());
				}
			});

			let $privacyWrap = $form.find('.form-privacy');
			if (!$form.find('input[name="privacyConsent"]').prop('checked')) {
				valid = false;
				$privacyWrap.addClass('has-error');
			} else {
				$privacyWrap.removeClass('has-error');
			}

			return valid;
		},

		// Client-side mirror of FormElementScripts::validateFile() - a UX convenience only, the
		// server re-checks count/type/size authoritatively (a client-side-only check can always
		// be bypassed). Reads its limits from the data-file-* attributes Form.fluid.html renders
		// from that same field's file_max_count/file_allowed_types/file_max_size TCA config.
		validateFileField: function ($wrap, isRequired) {
			let $input = $wrap.find('input[type="file"]');
			let files = $input[0] && $input[0].files ? $input[0].files : [];

			$wrap.removeClass('has-error');
			$wrap.find('.form-field-error').text('');

			if (files.length === 0) {
				if (isRequired) {
					$wrap.addClass('has-error');
					$wrap.find('.form-field-error').text(this.getRequiredMessage());
					return false;
				}
				return true;
			}

			let maxCount = parseInt($wrap.data('fileMaxCount'), 10) || 1;
			if (files.length > maxCount) {
				$wrap.addClass('has-error');
				$wrap.find('.form-field-error').text('Too many files selected (max ' + maxCount + ').');
				return false;
			}

			let allowedTypes = String($wrap.data('fileAllowedTypes') || '')
				.split(',')
				.map(function (ext) { return ext.trim().toLowerCase(); })
				.filter(function (ext) { return ext !== ''; });
			let maxSizeBytes = (parseInt($wrap.data('fileMaxSize'), 10) || 5) * 1024 * 1024;

			for (let i = 0; i < files.length; i++) {
				let file = files[i];
				let extension = file.name.split('.').pop().toLowerCase();

				if (allowedTypes.length > 0 && allowedTypes.indexOf(extension) === -1) {
					$wrap.addClass('has-error');
					$wrap.find('.form-field-error').text('File type not allowed: ' + file.name);
					return false;
				}

				if (file.size > maxSizeBytes) {
					$wrap.addClass('has-error');
					$wrap.find('.form-field-error').text('File too large: ' + file.name);
					return false;
				}
			}

			return true;
		},

		// Plain hardcoded string rather than a translation lookup - this JS file has no
		// server-rendered localization hook today; revisit if/when the form is used on a
		// non-German-primary page and this needs to vary by frontend language.
		getRequiredMessage: function () {
			return 'This field is required.';
		},

		handleSubmit: function (form) {
			let that = this;
			let $form = $(form);

			if (!that.validateForm(form)) {
				return;
			}

			if ($form.data('isSubmitting')) {
				return;
			}
			$form.data('isSubmitting', true);

			$.ajax({
				type: 'post',
				cache: false,
				data: new FormData(form),
				url: '?type=1758600000',
				processData: false,
				contentType: false
			}).done(function (data) {
				let response;
				try {
					response = JSON.parse(data);
				} catch (e) {
					response = {success: false};
				}

				$form.find('.form-response').addClass('inactive');

				if (response.success) {
					$form.find('.form-response--success').removeClass('inactive');
					form.reset();
					that.applyTopic(form, $form.find('.form-topic-select').val());
				} else {
					$form.find('.form-response--error').removeClass('inactive');
					if (response.missingFields) {
						response.missingFields.forEach(function (fieldKey) {
							$form.find('.form-field-wrap[data-field-key="' + fieldKey + '"]')
								.addClass('has-error')
								.find('.form-field-error').text(that.getRequiredMessage());
						});
					}
					if (response.invalidFields) {
						response.invalidFields.forEach(function (fieldKey) {
							$form.find('.form-field-wrap[data-field-key="' + fieldKey + '"]')
								.addClass('has-error')
								.find('.form-field-error').text('This file does not meet the allowed count/type/size.');
						});
					}
				}
			}).fail(function () {
				$form.find('.form-response').addClass('inactive');
				$form.find('.form-response--error').removeClass('inactive');
			}).always(function () {
				$form.data('isSubmitting', false);
			});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicFormElement);

	$(document).ready(function () {
		cologic.initFormElement();
	});
}());
